/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KoreaOutboundOrderVo
 */
export interface KoreaOutboundOrderVo {
    /**
     * 订单ID
     * @type {number}
     * @memberof KoreaOutboundOrderVo
     */
    orderId?: number;
    /**
     * 订单号
     * @type {string}
     * @memberof KoreaOutboundOrderVo
     */
    orderCode?: string;
    /**
     * 本地运输方式
     * @type {string}
     * @memberof KoreaOutboundOrderVo
     */
    krLocalTransportMethod?: string;
    /**
     * 出库运单号
     * @type {string}
     * @memberof KoreaOutboundOrderVo
     */
    ivc?: string;
    /**
     * coupang预约码
     * @type {string}
     * @memberof KoreaOutboundOrderVo
     */
    coupangInboundCode?: string;
    /**
     * coupang仓库ID
     * @type {number}
     * @memberof KoreaOutboundOrderVo
     */
    coupangWarehouseId?: number;
    /**
     * 库位
     * @type {string}
     * @memberof KoreaOutboundOrderVo
     */
    locationNos?: string;
    /**
     * 商品总数量
     * @type {number}
     * @memberof KoreaOutboundOrderVo
     */
    goodsTotalQuantity?: number;
    /**
     * 商品总重量
     * @type {number}
     * @memberof KoreaOutboundOrderVo
     */
    goodsTotalWeight?: number;
    /**
     * 包装后的箱子总数量，按订单包装箱快照统计，包含已上托的箱子
     * @type {number}
     * @memberof KoreaOutboundOrderVo
     */
    totalBoxCount?: number;
    /**
     * 包装后的箱子总重量（kg），汇总包装箱快照的实测重量，不包含托盘自重
     * @type {number}
     * @memberof KoreaOutboundOrderVo
     */
    totalBoxWeight?: number;
    /**
     * 收货人姓名
     * @type {string}
     * @memberof KoreaOutboundOrderVo
     */
    receiverName?: string;
    /**
     * 请求类型
     * @type {number}
     * @memberof KoreaOutboundOrderVo
     */
    requestType?: number;
    /**
     * 请求类型名称
     * @type {string}
     * @memberof KoreaOutboundOrderVo
     */
    requestTypeName?: string;
}

/**
 * Check if a given object implements the KoreaOutboundOrderVo interface.
 */
export function instanceOfKoreaOutboundOrderVo(value: object): value is KoreaOutboundOrderVo {
    return true;
}

export function KoreaOutboundOrderVoFromJSON(json: any): KoreaOutboundOrderVo {
    return KoreaOutboundOrderVoFromJSONTyped(json, false);
}

export function KoreaOutboundOrderVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KoreaOutboundOrderVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'krLocalTransportMethod': json['krLocalTransportMethod'] == null ? undefined : json['krLocalTransportMethod'],
        'ivc': json['ivc'] == null ? undefined : json['ivc'],
        'coupangInboundCode': json['coupangInboundCode'] == null ? undefined : json['coupangInboundCode'],
        'coupangWarehouseId': json['coupangWarehouseId'] == null ? undefined : json['coupangWarehouseId'],
        'locationNos': json['locationNos'] == null ? undefined : json['locationNos'],
        'goodsTotalQuantity': json['goodsTotalQuantity'] == null ? undefined : json['goodsTotalQuantity'],
        'goodsTotalWeight': json['goodsTotalWeight'] == null ? undefined : json['goodsTotalWeight'],
        'totalBoxCount': json['totalBoxCount'] == null ? undefined : json['totalBoxCount'],
        'totalBoxWeight': json['totalBoxWeight'] == null ? undefined : json['totalBoxWeight'],
        'receiverName': json['receiverName'] == null ? undefined : json['receiverName'],
        'requestType': json['requestType'] == null ? undefined : json['requestType'],
        'requestTypeName': json['requestTypeName'] == null ? undefined : json['requestTypeName'],
    };
}

export function KoreaOutboundOrderVoToJSON(json: any): KoreaOutboundOrderVo {
    return KoreaOutboundOrderVoToJSONTyped(json, false);
}

export function KoreaOutboundOrderVoToJSONTyped(value?: KoreaOutboundOrderVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'orderCode': value['orderCode'],
        'krLocalTransportMethod': value['krLocalTransportMethod'],
        'ivc': value['ivc'],
        'coupangInboundCode': value['coupangInboundCode'],
        'coupangWarehouseId': value['coupangWarehouseId'],
        'locationNos': value['locationNos'],
        'goodsTotalQuantity': value['goodsTotalQuantity'],
        'goodsTotalWeight': value['goodsTotalWeight'],
        'totalBoxCount': value['totalBoxCount'],
        'totalBoxWeight': value['totalBoxWeight'],
        'receiverName': value['receiverName'],
        'requestType': value['requestType'],
        'requestTypeName': value['requestTypeName'],
    };
}

